import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import KNB from '@dp/knb';
import Drip from 'drip';
import UA from 'drip/ua';
import { openMap } from '@/utils';
export default {
  name: 'detail-Venue-address',
  props: {
    showTimeRange: String,
    shopName: String,
    cityName: String,
    shopId: String,
    address: String,
    lat: Number,
    lng: Number,
    isLive: Boolean
  },
  methods: {
    goToshop: function goToshop() {
      if (this.isLive) return;
      if (location.href.includes('fromSearch=true')) {
        return;
      }
      var shopId = this.shopId,
        lat = this.lat,
        lng = this.lng,
        address = this.address,
        shopName = this.shopName;
      openMap({
        shopId: shopId,
        lat: lat,
        lng: lng,
        address: address,
        shopName: shopName
      });
    }
  }
};